<template>
  <div class="foot">
    <ul class="foot-ul">
      <li><router-link to="/home">网站首页</router-link></li>
      <li><router-link to="/solution">解决方案</router-link></li>
      <li><router-link to="/tSupport">技术支持</router-link></li>
      <li><router-link to="/news">新闻中心</router-link></li>
      <li><router-link to="/about">关于我们</router-link></li>
    </ul>
    <div class="foot-detail">
      <img src="../assets/img/home/home_foot_logo.png" alt="">
      <div class="foot-detail-info">
        <div>
          <img src="../assets/img/home/home_foot_phone.png" alt="">
          <div>电话：0512-66872965</div>
        </div>
        <div>
          <img src="../assets/img/home/home_foot_email.png" alt="">
          <div>邮箱：szshch@foxmail.com</div>
        </div>
        <div>
          <img src="../assets/img/home/home_foot_address.png" alt="">
          <div>地址：苏州工业园区园科大厦3楼</div>
        </div>
      </div>
      <div class="foot-detail-qrcode">
        <img src="../assets/img/home/home_foot_qrcode.png" alt="">
        <div>吉埃思微信公众平台</div>
      </div>
    </div>
    <div class="foot-copyright">
      <div>Copyright@苏州吉埃思数据信息科技有限公司</div>                  
      <div>技术支持：苏州吉埃思开发部门</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      navShow:true
    }
  },
  methods:{
    
  }
}
</script>

<style lang="scss" scoped>
 .foot{
    width: 100%;
    background: #242933;
    font-size: 0.24rem;
    color: #999999;
    &-ul{
      list-style-type: none;
      margin: auto;
      text-align: center;
      width: 12rem;
      display: flex;
      justify-content: space-evenly;
      padding:0.5rem 0;
      font-size: 0.24rem;
      li{
        letter-spacing: 4px;
        a{
          text-decoration: none;
          color: #999999;
        }
      }
      .router-link-exact-active {
        color: #0052D9;
      }
    }
    &-detail{
      border-bottom: 1px solid rgba(191, 191, 191, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      padding:0.5rem 0;
      >img{
        width: 1.69rem;
        height: 1.12rem;
        padding-right:0.5rem;
        border-right:1px solid rgba(204, 204, 204, 0.1);
      }
      &-info{
        margin-left: 1rem;
        padding-right: 1rem;
        border-right: 1px solid rgba(204, 204, 204, 0.1);
        >div{
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          >img{
            margin-right: 0.2rem;
          }
        }
      }
      &-qrcode{
        margin-left: 0.76rem;
        text-align: center;
        >img{
          width: 1.12rem;
          height: 1.12rem;
        }
      }
    }
    &-copyright{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      >div{
        font-size: 0.18rem;
        color: #999;
        margin: 0.3rem 0.3rem;
      }
    }
 }
</style>